import { OneTermAssignmentCtrl } from './one-term-assignment.controller';

export const OneTermAssignment = {
  controller: OneTermAssignmentCtrl,
  bindings: {
    prevStep: '&',
    nextStep: '&',
  },
  template: require('./one-term-assignment.html'),
};
